import { useTranslation } from "react-i18next";
import { SeV2AttachmentSource } from "../../../autogen/bff-api";

// Mirrors the file types the BFF accepts (UploadService.parseMimeType). Used for an inline,
// pre-upload check so the user sees a friendly message instead of a failed request.
export const ALLOWED_ATTACHMENT_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "jpg",
  "jpeg",
  "png",
];

export const isAllowedAttachmentFile = (fileName: string): boolean => {
  const extension = fileName.includes(".") ? fileName.split(".").pop()?.toLowerCase() ?? "" : "";
  return ALLOWED_ATTACHMENT_EXTENSIONS.includes(extension);
};

export const useAttachmentSourceLabel = (): ((source: SeV2AttachmentSource) => string) => {
  const { t } = useTranslation();
  return (source: SeV2AttachmentSource) => {
    switch (source) {
      case SeV2AttachmentSource.Request:
        return t("From the request");
      case SeV2AttachmentSource.Offer:
        return t("From the tender");
      case SeV2AttachmentSource.Upload:
        return t("Uploaded");
    }
  };
};
